//import { MassGridEditor } from './mass/MassGridEditor';
//import { MassAdvancedEditor } from '@pages/map/ui/mass/MassAdvancedEditor';

import { MassDxfExport } from '@pages/mass/mass-dxf-export';
import { Notify } from '@shared/ui-native/Notify';
import { childFilterPresets } from '@shared/ui-native/Tree';
import { Dropdown } from '@shared/ui-react/Dropdown';
import { Tree } from '@shared/ui-react/Tree';
import { cs } from '@shared/utils/utils-classname';
import './MassPanelList.scss';

import { Ajax, Ajax2 } from '@shared/Ajax';
import { Events } from '@shared/Events';
import { Button } from '@shared/ui-react/Button';
import { computed, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';


@observer
export class MassPanelList extends React.Component<{
    treeData: ITreeData,
    massMap?: any,
    massGridEditor?: { open: any, close: any, edit: any },
    massAdvancedEditor?: { open: any, close: any, edit: any },
    editTask?: (sheet: Mass.Sheet, folderId: number) => void,
    openTask?: (sheet: Mass.Sheet) => void,
    onLoaded?: Function
}, {}> {
    @observable sheets: Mass.Sheets[] = [];
    @observable isLoading = false;
    fetchPromise: Promise<any> = null;

    public tree: Tree;
    @observable folderId = null;
    @computed get sheetsInFolder(): Mass.Sheets[] {
        return this.sheets.filter(s => s.folderId == this.folderId);
    }

    constructor(
        props: any
    ) {
        super(props);
        makeObservable(this);
    }

    componentDidMount() {
        this.fetchSheets();
    }

    componentWillUnmount() {
        Events.off('mass-fetch-sheets', this.fetchSheets);
    }

    componentDidUpdate(prevProps) {
        if (!this.tree && prevProps.treeData !== this.props.treeData) {
            this.fetchSheets();
        }
    }

    getCounts = () => {
        const calc = () => {
            const counts = {};
            this.sheets.forEach(s => {
                counts[s.folderId] ? counts[s.folderId] += 1 : counts[s.folderId] = 1;
            });
            return counts;
        }

        if (this.fetchPromise) {
            return new Promise(done => {
                this.fetchPromise.then(() => done(calc()));
            });
        }
        return Promise.resolve(calc())
    }

    render() {
        if (!this.props.treeData) return <div className='overlay-loading no-bg' style={{ height: '100%' }}></div>;

        const massMap = this.props.massMap;

        return (
            <div id='map-panel-mass'
                className={cs('flex-column', { 'overlay-loading': (massMap && massMap.loading) || this.isLoading })}>

                {massMap && <>
                    <nav className='flex-row' style={{ flexShrink: 0 }}>
                        <Button secondary onClick={this.createGridSheet}>+ {__('mass.task_type.grid')}</Button>
                        &nbsp;
                        <Button secondary onClick={this.createAdvancedSheet}>+ {__('mass.task_type.advanced')}</Button>
                    </nav>

                    <div style={{ margin: '1em 0', flexShrink: 0 }} className='flex-row'>
                        <label className='checkbox-label'>
                            <input type='checkbox' checked={massMap.showLabels} onChange={massMap.toggleLabels} />
                            <span>{__('mass.map_options.show_labels')}</span>
                        </label>
                        <label className='checkbox-label'>
                            <input type='checkbox' checked={massMap.showCrossSectionLines}
                                onChange={massMap.toggleCrossSectionLines} />
                            <span>{__('mass.map_options.show_cross_section_lines')}</span>
                        </label>
                    </div>
                </>}

                { this.props.treeData && <Tree
                    ref={el => this.tree = el ? el : null}
                    treeData={this.props.treeData}
                    showRoot={true}
                    selectedId={this.folderId}
                    onSelect={node => this.folderId = node.id}
                    childFilter={childFilterPresets.onlyFolders}
                    headerControls={true}
                    showContextMenuCreateFolder={true}
                    hideEmptyFolders={true}
                    storageKey='mass-tasks-tree'
                    fetchContentCountsFn={this.getCounts}
                    onRender={tree => this.props.onLoaded ? this.props.onLoaded(tree) : null}
                />}

                <div className='sheet-items-list card'>
                    {this.sheetsInFolder.map(s => <div key={s.id}
                        className={cs('sheet-item', { selected: massMap && massMap.activeGridSheet === s })}>
                        <div onClick={() => this.openSheet(s)}>
                            <div><strong>{s.name}</strong></div>
                            <div className='details'>
                                {s.newVersionFlag && <span className='badge badge-warning' title='Newer version od models are available'>!</span>}
                                <span className='badge'>{kuura.getMessage('js_type.' + s.type)}</span>
                                {s.type === 'ADVANCE' &&
                                    <span>{__('mass.station')} {s.stationStart} - {s.stationEnd}, {__('mass.station_interval')} {s.stationInterval}</span>}
                                {s.type === 'AREA' &&
                                    <span>Cells: {s.externalData.cells}</span>}
                            </div>
                        </div>

                        <div className='sheet-item-dropdown flex-row'>
                            {massMap && massMap.activeGridSheet === s &&
                                <button onClick={massMap.clearMap} style={{ marginLeft: 'auto' }}>{__('general.clear')}</button>
                            }

                            <Dropdown closeOnBodyClick={true} className='ik-button-small'>
                                <i className='iki iki-more' />
                                <ul className='clickable'>
                                    {massMap && (s.type === 'AREA' || s.type === 'ADVANCE') && <li onClick={e => this.calculateSheet(s)}>{__('mass.action_calculate')}</li>}
                                    {massMap && (s.type === 'AREA' || s.type === 'ADVANCE') && <li onClick={e => this.checkCompletion(s)}>{__('mass.action_check_completion')}</li>}
                                    {(!massMap || (massMap && (s.type === 'AREA' || s.type === 'ADVANCE'))) && <li onClick={e => this.editSheet(s)}>{__('general.edit')}</li>}
                                    {(s.type === 'AREA') && <li onClick={e => MassDxfExport.export(s.id, s.name)}>{__('mass.action_export_grid_dxf')}</li>}
                                    <li onClick={e => this.deleteSheet(s)} style={{ color: '#FF473D' }}>{__('general.delete')}</li>
                                </ul>
                            </Dropdown>
                        </div>
                    </div>)}
                </div>
            </div>
        );
    }

    fetchSheets = () => {
        this.isLoading = true;
        this.fetchPromise = Ajax2({
            url: kuura.getContextPath() + '/api/1/mass/sheets.json',
            data: {
                projectId: kuura.getProjectId()
            }
        })

        this.fetchPromise.then((resp: Mass.Ajax.SheetsJsonResponse) => {
            resp.sheets.forEach(s => {
                if (s.folderId == null || s.folderId == -1) {
                    s.folderId = kuura.getRootFolderId();
                }

                if (s.type == 'AREA' && !s.externalData) {
                    s.externalData = {
                        rotation: 0,
                        cellWidth: 20,
                        cells: 0
                    };
                }
            });
            this.sheets = resp.sheets;
        }).finally(() => {
            this.isLoading = false;
            this.fetchPromise = null;
            this.tree?.tree?.fetchAndRenderContentCounts()?.then(() => {
                this.tree?.tree?.hideEmptyFoldersApply();
            })
            Events.on('mass-fetch-sheets', this.fetchSheets);
        });

        return this.fetchPromise;
    };

    createGridSheet = () => {
        if (this.props.massMap) {
            this.props.massMap.clearMap();
            this.props.massGridEditor.open(this.fetchSheets, this.folderId);
        }
    };

    deleteSheet = (sheet: Mass.Sheet) => {
        this.isLoading = true;
        if (!confirm(__('general.confirm_delete', sheet.name))) return false;

        Ajax({
            url: `/api/1/mass/sheet/${sheet.id}/delete.json`,
        }).done(() => {
            this.sheets = this.sheets.filter(s => s.id != sheet.id);
            this.tree?.tree?.fetchAndRenderContentCounts();
            Events.trigger('mass-sheet-deleted');
        }).fail(Notify.error)
            .always(() => {
                this.isLoading = false;
            });
    };

    openSheet = (sheet: Mass.Sheet) => {
        if (this.props.massMap) {
            this.props.massMap.openSheet({ ...sheet });
        }
        // mass page
        else if (typeof this.props.openTask === 'function') {
            this.props.openTask({ ...sheet });
        }
    }

    editSheet = (sheet: Mass.Sheet) => {
        if (this.props.massMap) {
            this.props.massMap.clearMap();
            if (sheet.type === 'AREA') {
                this.props.massGridEditor.edit(sheet as Mass.SheetArea, this.fetchSheets);
            }
            else if (sheet.type === 'ADVANCE') {
                this.props.massAdvancedEditor.edit(sheet as Mass.SheetAdvanced, this.fetchSheets);
            }
        }
        // mass page
        else if (typeof this.props.editTask === 'function') {
            this.props.editTask({ ...sheet }, this.folderId);
        }
    };

    calculateSheet = (sheet: Mass.Sheet) => {
        this.isLoading = true;
        return Ajax({
            url: `/api/1/mass/calculate.json`,
            data: {
                save: true,
                taskId: sheet.id,
                taskType: 3,
                topSurfId: sheet.model1Id,
                botSurfId: sheet.model2Id,
                limSurfId: sheet.model3Id,
                botSurfOff: 0,
                externalDataId: sheet.externalDataId,
            },
        }).always(() => this.isLoading = false)
            .done(resp => {
                Notify.success();
                this.checkCompletion(sheet);
                console.log('resp:', resp);
            }).fail(Notify.error);
    };

    checkCompletion = (sheet: Mass.Sheet) => {
        this.isLoading = true;
        return Ajax({
            url: `/api/1/mass/check_completion.json`,
            data: {
                taskId: sheet.id,
                taskType: 3,
            },
        }).always(() => this.isLoading = false)
            .done(resp => {
                Notify.success();
                this.props.massMap.openSheet(sheet as Mass.SheetArea);
                console.log('resp:', resp);
            }).fail(Notify.error);
    };

    createAdvancedSheet = () => {
        if (this.props.massMap) {
            this.props.massMap.clearMap();
            this.props.massAdvancedEditor.open(this.fetchSheets, this.folderId);
        }
    };

}
